var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.content,"placement":_vm.placement}},[_c('i',{staticClass:"el-icon-question",attrs:{"size":14}})])
}
var staticRenderFns = []

export { render, staticRenderFns }